"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const httpRepository_1 = __importDefault(require("./httpRepository"));
const UserRepository = {
    getUser: async () => {
        const response = await httpRepository_1.default.tradeshiftGo().get('/rest/user', {});
        return response.data;
    },
    getUserById: async (id) => {
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/users/${id}`);
        return response.data;
    },
    getUserByEmail: async (email) => {
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/users?email=${email}`);
        return response.data;
    },
    sendInvitation: async (user) => {
        let url = '/rest/users/invite';
        if (user.teamId) {
            url = `/rest/teams/${user.teamId}/users/invite`;
        }
        const response = await httpRepository_1.default.tradeshiftGo().post(url, user);
        return response.data;
    },
    saveUserData: async (user) => {
        const response = await httpRepository_1.default.tradeshiftGo().put(`/rest/users/${user?.userId}`, user);
        return response.data;
    },
    saveAvatar: async ({ avatar, user }) => {
        const data = new FormData();
        data.append('file', avatar);
        const response = await httpRepository_1.default.tradeshiftGoMulti().put(`/rest/users/${user?.userId}/avatar`, data);
        return response.data;
    },
    verifyAccess: async ({ objectId, operationId, teamId, userId, groupId }) => {
        const url = teamId && userId
            ? `/rest/teams/${teamId}/users/${userId}/accesslist/operation/${operationId}/object/${objectId}`
            : `/rest/accesslist/operation/${operationId}/object/${objectId}${groupId ? `?groupId=${groupId}` : ''}`;
        const response = await httpRepository_1.default.tradeshiftGo().get(url);
        return response.data;
    },
    verifyTeamAccess: async ({ teamId, operationId, objectId }) => {
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/teams/${teamId}/accesslist/operation/${operationId}/object/${objectId}`);
        return response.data;
    },
    getUsersByRoleId: async (roleId) => {
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/users/role/${roleId}`);
        return response.data;
    },
};
exports.default = UserRepository;
